import axios from "axios/index";
import { dispatchError, API_BASE, config as ApiConfig } from "../api";

export default store => {
  return {
    $store: store,
    list(locationId, params) {
      this.$store.commit("loading", true);
      params = params === undefined ? {} : params;

      return axios(
        Object.assign(ApiConfig(this.$store), {
          method: "get",
          url: API_BASE + `/readers/`,
          params
        })
      )
        .then(response => {
          this.$store.commit("loading", false);
          return response.data;
        })
        .catch(error => {
          if (error.response === undefined) {
            dispatchError(
              this.$store,
              "Error de conexión. Inténtelo más tarde"
            );
          } else {
            dispatchError(this.$store, error.response.data.message);
            throw error;
          }
        });
    },
    get(id) {
      this.$store.commit("loading", true);

      return axios(
        Object.assign(ApiConfig(this.$store), {
          method: "get",
          url: API_BASE + `/readers/${id}/`
        })
      )
        .then(response => {
          this.$store.commit("loading", false);
          return response.data;
        })
        .catch(error => {
          if (error.response === undefined) {
            dispatchError(
              this.$store,
              "Error de conexión. Inténtelo más tarde"
            );
          } else {
            dispatchError(this.$store, error.response.data.message);
            throw error;
          }
        });
    },
    add(data) {
      this.$store.commit("loading", true);
      return axios(
        Object.assign(ApiConfig(this.$store), {
          method: "post",
          url: API_BASE + `/readers/`,
          data: data
        })
      )
        .then(response => {
          this.$store.commit("loading", false);
          return response.data;
        })
        .catch(error => {
          if (error.response === undefined) {
            dispatchError(
              this.$store,
              "Error de conexión. Inténtelo más tarde"
            );
          } else {
            dispatchError(this.$store, error.response.data.message);
            throw error;
          }
        });
    },
    update(data) {
      this.$store.commit("loading", true);

      return axios(
        Object.assign(ApiConfig(this.$store), {
          method: "put",
          url: API_BASE + `/readers/${data.id}/`,
          data: data
        })
      )
        .then(response => {
          this.$store.commit("loading", false);
          return response.data;
        })
        .catch(error => {
          if (error.response === undefined) {
            dispatchError(
              this.$store,
              "Error de conexión. Inténtelo más tarde"
            );
          } else {
            dispatchError(this.$store, error.response.data.message);
            throw error;
          }
        });
    }
  };
};
